import {
  Grid,
  IconButton,
  Typography,
  Paper,
  CardHeader,
  Box,
  CardContent,
} from "@mui/material";
import { useSnack } from "../../redux/snack/snackHooks";
import { useState, useCallback, useEffect } from "react";
import { Card, makeStyles } from "@material-ui/core";
import {
  DadosAnexosEmissaoCTe,
  DadosSolicitacaoEmissao,
} from "../../model/entities/SolicitacaoEmissaoCTe";
import dayjs from "dayjs";
import { Close, Image, AttachFile, CloudUpload } from "@mui/icons-material";
import { useDropzone } from "react-dropzone";
import solicitacaoEmissaoCTeApi from "../../api/solicitacaoEmissaoCTeApi";
import { faltaMenosDeUmaHora } from "../../helpers/helper";
import { passouDe24Horas } from "../../helper";
import DisclaimerAlerta from "../../components/Generics/Disclaimer";
import Info from "../../components/Generics/Info";
import CheckBoxGeneric from "../../components/Generics/CheckBoxGeneric";
import ButtonGeneric from "../../components/Generics/ButtonGeneric";
import LoadingBackdrop from "../../components/Generics/LoadingBackdrop";

type Props = {
  solicitacao: DadosSolicitacaoEmissao;
};

const InformacoesCTe: React.FC<Props> = (props) => {
  const { solicitacao } = props;
  const mostrarSnack = useSnack();
  const classes = useStyles();
  const [carregandoAnexos, setCarregandoAnexos] = useState(false);
  const [anexos, setAnexos] = useState<File[]>([]);
  const [bloblUrlImagemSolicitacao, setBlobUrl] = useState<string | null>(null);
  const [mdfeEncerrado, setMdfeEncerrado] = useState<boolean>(
    solicitacao.mdfeEncerrado
  );

  const atualizarSolicitacao = async (x: boolean) => {
    solicitacaoEmissaoCTeApi
      .update({
        ...solicitacao,
        mdfeEncerrado: x,
      })
      .catch((error) => {
        console.error("Erro ao atualizar a solicitação:", error);
      });
    setMdfeEncerrado(x);
  };

  useEffect(() => {
    getAnexos();
    if (solicitacao.urlImagem) {
      const byteCharacters = atob(solicitacao.urlImagem);
      const byteNumbers = new Array(byteCharacters.length)
        .fill(0)
        .map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "image/jpeg" });
      const url = URL.createObjectURL(blob);
      setBlobUrl(url);

      return () => URL.revokeObjectURL(url);
    }
  }, [solicitacao.urlImagem]);

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      setAnexos([...anexos, ...acceptedFiles]);
      mostrarSnack("Arquivos adicionados com sucesso!", "success");
    },
    [anexos, mostrarSnack]
  );

  const getAnexos = async () => {
    try {
      const res: DadosAnexosEmissaoCTe[] =
        await solicitacaoEmissaoCTeApi.getAnexosSolicitacao(solicitacao.id);

      const arquivos: File[] = res
        .filter((item) => item.tipoAnexo === "RESPOSTA")
        .map((item) => {
          const byteString = atob(item.arquivo); // decodifica base64
          const arrayBuffer = new ArrayBuffer(byteString.length);
          const uint8Array = new Uint8Array(arrayBuffer);

          for (let i = 0; i < byteString.length; i++) {
            uint8Array[i] = byteString.charCodeAt(i);
          }

          const blob = new Blob([uint8Array], { type: item.tipoConteudo });
          return new File([blob], item.nomeArquivo, {
            type: item.tipoConteudo,
          });
        });

      setAnexos(arquivos);

      setCarregandoAnexos(false);
    } catch (erro: any) {
      mostrarSnack("Erro ao buscar anexos", "error");
      console.log("Erro ao buscar anexos", erro);
      setCarregandoAnexos(false);
    }
  };

  const salvar = async () => {
    try {
      setCarregandoAnexos(true);

      await solicitacaoEmissaoCTeApi.uploadAnexosEmissaoCte(
        solicitacao.id,
        anexos
      );
      mostrarSnack("Anexos enviados para o motorista", "success");
      setCarregandoAnexos(false);
    } catch (erro: any) {
      setCarregandoAnexos(false);
      mostrarSnack("Erro ao enviar anexo ao motorista", "error");
      console.log("Erro ao enviar anexo ao motorista", erro);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [".jpeg", ".jpg", ".png"],
      "application/pdf": [".pdf"],
    },
  });

  const handleRemoveFile = (index: number) => {
    const newAnexos = [...anexos];
    newAnexos.splice(index, 1);
    setAnexos(newAnexos);
    mostrarSnack("Arquivo removido", "info");
  };

  // const naoPodeMaisEnviar =
  //   passouDe24Horas(solicitacao.dataHoraSolicitacao) ||
  //   solicitacao.status === "EMITIDO";

  const naoPodeMaisEnviar = false;

  if (carregandoAnexos) {
    return <LoadingBackdrop open={carregandoAnexos} />;
  }

  return (
    <Grid container spacing={2}>
      <Grid item md={12} style={{ textAlign: "center" }}>
        {solicitacao.status === "SOLICITADO" && naoPodeMaisEnviar && (
          <DisclaimerAlerta message="⚠️ Atenção! Já se passou o prazo de 24h da emissão do CTe. Faça o envio manualmente para o motorista!" />
        )}

        {faltaMenosDeUmaHora(solicitacao.dataHoraSolicitacao) &&
          !passouDe24Horas(solicitacao.dataHoraSolicitacao) && (
            <DisclaimerAlerta
              message="⚠️ Atenção! Faltam menos de 1 hora para o prazo de 24h da emissão do CTe. Verifique a
                emissão e a liberação imediata!"
            />
          )}
      </Grid>

      <Grid item md={12} xs={12}>
        <Info label={"Motorista"} children={solicitacao.nomeMotorista} />
      </Grid>

      <Grid item md={4} xs={12}>
        <Info
          label={" Número da Nota Fiscal"}
          children={solicitacao.numeroNota}
          object
        />
      </Grid>

      <Grid item md={8} xs={12}>
        <Info label={"Chave da Nota Fiscal"} children={solicitacao.chaveNota} />
      </Grid>

      <Grid item md={4} xs={12}>
        <Info label={"Placa do Veículo"} children={solicitacao.placaVeiculo} />
      </Grid>

      <Grid item md={4} xs={12}>
        <Info
          label={"Placa do implemento 1"}
          children={solicitacao.placaImplemento1}
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <Info
          label={"Placa do implemento 2"}
          children={solicitacao.placaImplemento2}
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <Info
          label={"Data da Solicitação"}
          children={dayjs(solicitacao.dataHoraSolicitacao).format(
            "DD/MM/YYYY - HH:mm"
          )}
        />
      </Grid>

      <Grid item md={8} xs={12}>
        <Info
          label={"Telefone do Motorista"}
          children={solicitacao.telefoneMotorista.replace("whatsapp:+", "")}
        />
      </Grid>

      <Grid item md={6} xs={12}>
        <Info
          label={"E-mail enviado para"}
          children={solicitacao.emailDestinatario}
        />
      </Grid>

      <Grid item md={6} xs={12}>
        <Info
          label={"Email enviado com cópia para"}
          children={
            solicitacao.emailDestinatarioCopia &&
            solicitacao.emailDestinatarioCopia.split(",").map((item) => (
              <>
                {item.trim()}
                <br />
              </>
            ))
          }
        />
      </Grid>

      {solicitacao.postoCombustivel && (
        <>
          <Grid item md={4} xs={12}>
            <Info
              label={"Posto para impressão"}
              children={solicitacao.postoCombustivel.nome}
            />
          </Grid>

          <Grid item md={8} xs={12}>
            <Info
              label={"E-mail do posto"}
              children={solicitacao.postoCombustivel.email}
            />
          </Grid>
        </>
      )}

      <Grid item md={12} xs={12}>
        <CheckBoxGeneric
          label={"MDFe encerrado"}
          value={mdfeEncerrado}
          onChange={(x) => {
            atualizarSolicitacao(x);
          }}
        />
      </Grid>

      {/* Imagem da NF-e enviada no WPP */}
      {solicitacao.urlImagem && bloblUrlImagemSolicitacao && (
        <Grid item md={12} xs={12}>
          <Paper elevation={1} className={classes.imageContainer}>
            <a
              href={bloblUrlImagemSolicitacao}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.anexoItemPrincipal}
            >
              <Typography variant="subtitle1" className={classes.sectionTitle}>
                <Image fontSize="small" className={classes.titleIcon} />
                Foto NF-e
              </Typography>
            </a>
          </Paper>
        </Grid>
      )}

      {/* Drag and drop CT-e e Mdfe */}
      <Grid item xs={12}>
        <Card
          style={{
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
          }}
        >
          <CardHeader
            title={
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="h6">CT-e | MDF-e emitidos</Typography>
              </Box>
            }
          />
          <CardContent>
            <Grid item md={12}>
              {!naoPodeMaisEnviar && (
                <>
                  <Typography
                    variant="subtitle1"
                    className={classes.sectionTitle}
                  >
                    <AttachFile
                      fontSize="small"
                      className={classes.titleIcon}
                    />
                    Anexe aqui o CT-e e o MDF-e
                  </Typography>

                  <Paper
                    {...getRootProps()}
                    className={classes.dropzone}
                    elevation={0}
                  >
                    <input {...getInputProps()} />
                    <CloudUpload className={classes.uploadIcon} />
                    {isDragActive ? (
                      <Typography>Solte os arquivos aqui...</Typography>
                    ) : (
                      <div className={classes.dropzoneText}>
                        <Typography>
                          Arraste e solte arquivos aqui ou clique para
                          selecionar
                        </Typography>
                        <Typography variant="caption">
                          Suporta arquivos nos formatos JPG, PNG e PDF.
                        </Typography>
                      </div>
                    )}
                  </Paper>
                </>
              )}

              <Grid container spacing={1} className={classes.anexosContainer}>
                {anexos.map((anexo, index) => {
                  const fileUrl = URL.createObjectURL(anexo);

                  return (
                    <Grid item md={12} xs={12}>
                      <Paper elevation={1} className={classes.imageContainer}>
                        <a
                          href={fileUrl} // URL temporária para o arquivo
                          target="_blank"
                          rel="noopener noreferrer" // Boa prática para segurança
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            {/* Tornando o nome do arquivo clicável */}
                            <Typography variant="body2">
                              {index + 1} {anexo.name}
                            </Typography>

                            {!naoPodeMaisEnviar && (
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveFile(index);
                                }}
                              >
                                <Close fontSize="small" />
                              </IconButton>
                            )}
                          </div>
                        </a>
                      </Paper>
                    </Grid>
                  );
                })}
              </Grid>

              {!naoPodeMaisEnviar && anexos.length > 0 && (
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "center", marginTop: "15px" }}
                >
                  <ButtonGeneric
                    label={"Enviar ao motorista"}
                    onClick={salvar}
                  />
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  input: {
    width: "100%",
    minWidth: "350px",
    marginBottom: "35px",
    "@media (max-width: 768px)": {
      minWidth: "400px",
      marginBottom: "20px",
    },
  },
  button: {
    backgroundColor: "#3a7bd5 !important",
    color: "#fff !important",
    "&:hover": {
      backgroundColor: "#306bb5 !important",
    },
  },
  footer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "auto",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: 10,
    display: "flex",
    alignItems: "center",
  },
  titleIcon: {
    marginRight: 8,
    color: "#666",
  },

  imageContainer: {
    textAlign: "center",
    padding: 10,
    cursor: "pointer",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.05)",
    },
  },

  imageCaption: {
    color: "#3a7bd5",
    display: "block",
    marginTop: 8,
  },
  dropzone: {
    border: "2px dashed #ccc",
    borderRadius: 4,
    padding: 20,
    textAlign: "center",
    cursor: "pointer",
    backgroundColor: "rgba(0,0,0,0.02)",
    transition: "border 0.2s",
    "&:hover": {
      borderColor: "#3a7bd5",
    },
  },
  uploadIcon: {
    fontSize: 40,
    color: "#3a7bd5",
    marginBottom: 10,
  },
  dropzoneText: {
    marginTop: 8,
  },
  anexosContainer: {
    marginTop: "25px",
  },
  anexoItem: {
    position: "relative",
    height: 120,
    overflow: "hidden",
    margin: 0,
  },
  anexoItemPrincipal: {
    position: "relative",
    height: 120,
    overflow: "hidden",
    margin: 0,
    textDecoration: "none",
    color: "inherit",
  },
  anexoContent: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  anexoImage: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },
  pdfPreview: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#e53935",
    height: "100%",
  },
  removeButton: {
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: "rgba(255,255,255,0.7)",
    padding: 2,
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.9)",
    },
  },
  dialogContent: {
    position: "relative",
    padding: 8,
  },
  dialogImage: {
    maxWidth: "100%",
    maxHeight: "80vh",
    display: "block",
    margin: "0 auto",
  },
  closeButton: {
    position: "absolute",
    top: 8,
    right: 8,
    backgroundColor: "rgba(0,0,0,0.5) !important",
    color: "#fff !important",
    zIndex: 1,
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.7) !important",
    },
  },
}));

export default InformacoesCTe;
